module.exports = __webpack_public_path__ + "static/scrabblista-desktop-2.f4c37f12.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/project/scrabblista/img/scrabblista-desktop-2.png
// module id = 623
// module chunks = 230197332751855